import actions from './actions';
import * as api from '../../apis/vistacartApi';
import { trackCartLoadError, noticeError } from '../../apis/newRelicTracking';

const load =
  (
    tenant: string,
    shopperId: string,
    locale: string,
    shouldLoadOffline: boolean = false
  ) =>
  async (dispatch: any) => {
    dispatch(actions.CART_LOAD_START(tenant, shopperId));

    try {
      const cart = await api.getShopperCart(
        tenant,
        shopperId,
        shouldLoadOffline
      );
      cart.vistacartUrl = api.getVistaCartUrl();
      dispatch(actions.CART_LOAD_SUCCESS(cart, tenant, shopperId, locale));
    } catch (error: any) {
      if (!error.nrReporterSource) {
        noticeError(error);
      }
      trackCartLoadError(error);
      dispatch(actions.CART_LOAD_FAIL(error, tenant, shopperId));
    }
  };

const unload = () => async (dispatch: any) => {
  dispatch(actions.CART_CLEAR());
};

const cartChangedExternally = () => async (dispatch: any) => {
  dispatch(actions.CART_CHANGED_EXTERNALLY());
};

export default {
  load,
  unload,
  cartChangedExternally,
};
